"use client"

import Image from "next/image"
import { useTranslations } from "next-intl"
import {
  NotFoundRoot,
  SectionTitle,
  IllustrationWrapper,
  Title,
  Subtitle,
  CtaLink,
  CtaLinkText,
} from "./styles"

export interface NotFoundPageProps {
  title?: string | null
  subtitle?: string | null
  ctaText?: string | null
  illustrationUrl?: string | null
  ctaUrl?: string | null
  ctaIsInternal?: boolean
  ctaTarget?: string | null
}

export default function NotFoundPage({
  title,
  subtitle,
  ctaText,
  illustrationUrl,
  ctaUrl,
  ctaTarget,
}: NotFoundPageProps) {
  const t = useTranslations("InnerPages")

  const imageSrc = illustrationUrl || "/images/not-found/illustration.png"
  const href = ctaUrl || "/"

  return (
    <NotFoundRoot>
      <SectionTitle>
        <IllustrationWrapper>
          <Image
            src={imageSrc}
            alt="404"
            fill
            sizes="300px"
            style={{ objectFit: "contain" }}
          />
        </IllustrationWrapper>
        <Title component="h2">{title || t("pageNotFound")}</Title>
        {subtitle && <Subtitle variant="body1">{subtitle}</Subtitle>}
      </SectionTitle>
      <CtaLink
        href={href}
        target={ctaTarget ?? undefined}
        rel={ctaTarget === "_blank" ? "noopener noreferrer" : undefined}
      >
        <CtaLinkText variant="body1">
          {ctaText || t("backToHomepage")}
        </CtaLinkText>
      </CtaLink>
    </NotFoundRoot>
  )
}
